import { arrayMove } from "@dnd-kit/sortable"

export type SortableResourceId = number | string

export const reorderSortableItems = <Item>(
  items: Item[],
  activeId: SortableResourceId,
  overId: SortableResourceId,
  getItemId: (item: Item) => SortableResourceId,
  isItemSortable: (item: Item) => boolean = () => true,
) => {
  const sortableItems = items.filter(isItemSortable)
  const previousIndex = sortableItems.findIndex(
    (item) => getItemId(item) === activeId,
  )
  const nextIndex = sortableItems.findIndex(
    (item) => getItemId(item) === overId,
  )

  if (previousIndex < 0 || nextIndex < 0 || previousIndex === nextIndex) {
    return items
  }

  const reorderedItems = arrayMove(sortableItems, previousIndex, nextIndex)
  let sortableIndex = 0

  return items.map((item) => {
    if (!isItemSortable(item)) return item

    const nextItem = reorderedItems[sortableIndex]
    sortableIndex += 1

    return nextItem
  })
}
